<div class="calendar-timespan">
  <div class="calendar-timespan__title-container">
    @for (title of titles(); track title; let i = $index) {
      <span
        class="calendar-timespan__title"
        [ngStyle]="{ left: (i * 100) / titles().length + '%' }"
      >
        {{ title }}
      </span>
    }
    @for (title of titles(); track title; let i = $index) {
      <span
        class="calendar-timespan__dot"
        [ngStyle]="{ left: (i * 100) / titles().length + '%' }"
      ></span>
    }
  </div>
  <div class="calendar-timespan__container">
    <span
      class="calendar-timespan__offset"
      [ngStyle]="{ left: 0, width: getPercent(offset()) + '%' }"
    ></span>
    <span
      class="calendar-timespan__offset"
      [ngStyle]="{ right: 0, width: getPercent(periodLength() - duration() - offset()) + '%' }"
    ></span>
  </div>
</div>
@if (showLegend()) {
  <div class="legend">
    <div class="legend__fix"></div>
    <span>Active</span>
    <div class="legend__offset"></div>
    <span>Offset</span>
  </div>
}
